import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { downloadFile } from "@lib/helperFile"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import dayjs from "dayjs"

class ConfigurationPaymentService {
  public async create(body: any) {
    const res = await http.post(
      "/api/services/app/ConfigurationPayment/Create",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async update(body: any) {
    const res = await http.put(
      "/api/services/app/ConfigurationPayment/Update",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async active(id: number, isActive) {
    const res = await http.post(
      "api/services/app/ConfigurationPayment/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/ConfigurationPayment/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/ConfigurationPayment/GetAll", {
      params,
    })
    return res.data.result
  }
  public async getList(params?: any): Promise<any[]> {
    const res = await http.get(
      "api/services/app/ConfigurationPayment/GetList",
      {
        params: { isActive: true, ...params },
      }
    )
    const { result } = res.data
    return result
  }

  public async calculateConfigurationPayment(body: any) {
    const res = await http.post(
      "/api/services/app/ConfigurationPayment/CalculateConfigurationPayment",
      body
    )

    return res.data.result
  }

  public async validateBeforeImport(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post(
      "api/Imports/ConfigurationPayment/ValidateBeforeImport",
      formData,
      {
        headers: { "content-type": "multipart/form-data" },
      }
    )
    return result.data.result
  }

  public async importConfigurationPayment(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post(
      "api/Imports/ImportConfigurationPayment",
      formData,
      {
        headers: { "content-type": "multipart/form-data" },
      }
    )
    notifySuccess(LNotification("SUCCESS"), LNotification("IMPORT_SUCCESSFULLY"))
    return result.data.result
  }

  public async downloadImportTemplate(): Promise<void> {
    const res = await http.get("api/Imports/GetConfigurationPaymentTemplate", {
      responseType: "blob",
    })
    downloadFile(
      res.data,
      `Import-ConfigurationPayment-Template-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`
    )
  }

  public async checkCodeExist(code: string, excludeId?: number): Promise<boolean> {
    const res = await http.get(
      "api/services/app/ConfigurationPayment/GetCodeExist",
      { params: { code, excludeId } }
    )
    return res.data.result
  }
}

export default new ConfigurationPaymentService()
